export default {
  MuiButton: {
    disableFocusRipple: true
  }
};
